"use client";

import * as React from "react";

import { createSVGIcon } from "../../util";

export const Handmade = createSVGIcon(
  <>
    <path
      d="M8.92696 24.1549C11.0399 22.0737 11.6109 19.2619 10.2022 17.8745C8.7936 16.487 5.93879 17.0494 3.82584 19.1306C1.71289 21.2117 1.14192 24.0235 2.55056 25.411C3.9592 26.7984 6.81401 26.236 8.92696 24.1549Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4847 32.3293C18.5976 30.2482 19.1686 27.4363 17.76 26.0489C16.3513 24.6615 13.4965 25.2239 11.3836 27.305C9.27063 29.3861 8.69966 32.198 10.1083 33.5854C11.5169 34.9728 14.3717 34.4105 16.4847 32.3293Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7979 21.204L35 10.7785"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.6383 25.2998L25.3192 1.09766"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Handmade",
  { viewBox: "0 0 36 37", titleAccess: "Handmade", fill: "none" }
);
